import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, Alert, Spinner } from 'react-bootstrap';
import axios from 'axios';

const AssignDriverModal = ({ show, onHide, booking, refreshBookings }) => {
  const [drivers, setDrivers] = useState([]);
  const [selectedDriver, setSelectedDriver] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const fetchAvailableDrivers = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('adminToken');
      const response = await axios.get(`${process.env.REACT_APP_API_URL}/admin/drivers`, {
        headers: { 'x-auth-token': token },
        params: { isAvailable: true }
      });
      setDrivers(response.data.drivers);
    } catch (err) {
      console.error('Error fetching drivers:', err);
      setError(err.response?.data?.error || 'Failed to load available drivers');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (show) {
      fetchAvailableDrivers();
      if (booking?.driver) {
        setSelectedDriver(booking.driver._id);
      }
    }
  }, [show, booking]);

  const handleAssignDriver = async () => {
    try {
      setLoading(true);
      setError('');
      
      const token = localStorage.getItem('adminToken');
      
      const response = await axios.put(`${process.env.REACT_APP_API_URL}/admin/bookings/${booking._id}/assign-driver`,
        { driverId: selectedDriver },
        { headers: { 'x-auth-token': token } }
      );
      
      if (response.data.success) {
        refreshBookings();
        onHide();
      }
    } catch (err) {
      console.error('Error assigning driver:', err);
      setError(err.response?.data?.error || 'Failed to assign driver');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal show={show} onHide={onHide} centered>
      <Modal.Header closeButton>
        <Modal.Title>
          {booking?.driver ? 'Reassign Driver' : 'Assign Driver'}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        
        {loading && !drivers.length ? (
          <div className="text-center">
            <Spinner animation="border" variant="primary" />
          </div>
        ) : (
          <Form.Group className="mb-3">
            <Form.Label>Select Available Driver</Form.Label>
            <Form.Select 
              value={selectedDriver}
              onChange={(e) => setSelectedDriver(e.target.value)}
              disabled={loading}
            >
              <option value="">Select a driver</option>
              {drivers.map(driver => (
                <option key={driver._id} value={driver._id}>
                  {driver.name} - {driver.phone} ({driver.licenseNumber})
                </option>
              ))}
            </Form.Select>
          </Form.Group>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide} disabled={loading}>
          Cancel
        </Button>
        <Button 
          variant="primary" 
          onClick={handleAssignDriver}
          disabled={!selectedDriver || loading}
        >
          {loading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            booking?.driver ? 'Reassign Driver' : 'Assign Driver'
          )}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AssignDriverModal;